module.exports = __webpack_public_path__ + "img/video-bg.aa3707a5.png";